/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: LGPL-2.1-only
 */

:host {
  --qds-control-hero-border-radius: 50%;
  --qds-control-border-radius: 50%;

  display: block;
  position: relative;
  border-radius: inherit;
}

:host([size="small"]) {
  --qds-web-media-button-size: var(--qds-control-small-height);
}

:host([size="standard"]) {
  --qds-web-media-button-size: var(--qds-control-standard-height);
}

:host([size="large"]) {
  --qds-web-media-button-size: var(--qds-control-large-height);
}

:host([size="hero"]) {
  --qds-web-media-button-size: var(--qds-control-hero-height);
}

video,
iframe,
img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: inherit;
}

.modal-container {
  height: 100%;
  border-radius: inherit;
}

.player-button {
  position: absolute;
  top: var(--qds-web-media-top, none);
  inset-inline-end: var(
    --qds-web-media-button-position-block-end,
    calc(50% - calc(var(--qds-web-media-button-size) / 2))
  );
  bottom: var(
    --qds-web-media-button-position-bottom,
    calc(50% - calc(var(--qds-web-media-button-size) / 2))
  );
  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */
  inset-inline-start: var(--qds-web-media-left, none);
  z-index: 1; /* Needed for bock hero emphasized desktop */
}

.modal-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

qds-dialog {
  --qds-theme-popup-background: #1f2729; /* stylelint-disable-line color-no-hex */
  --qds-popup-padding: none;

  position: relative;
  border-radius: 0;

  iframe {
    height: 90vh;
    aspect-ratio: 2/1;
  }

  .video-container-modal {
    display: block;
    position: relative;
    max-width: 860px;
    max-height: 700px;
  }

  video {
    aspect-ratio: 2/1;
  }

  .player-button[aria-label^="Pause"] {
    --qds-web-media-button-position-block-end: 16px;
    --qds-web-media-button-position-bottom: 16px;
  }

  .close-button {
    --qds-theme-signature-color-default: #3dcd58; /* stylelint-disable-line color-no-hex */
    --qds-theme-signature-color-contrast: #030303; /* stylelint-disable-line color-no-hex */

    align-self: flex-end;
    margin: 16px 16px 0;
  }
}

@media (width < 767px) {
  qds-dialog iframe {
    width: 80vw;
    aspect-ratio: 2/1;
  }
}
